import { apiUrl } from "../utils/api";

export type MailTemplateScope = "user" | "tenant";

/** Mail-Vorlage (SP7, B1) — spiegelt MailTemplateResponse des Backends. */
export interface MailTemplate {
    id: number;
    name: string;
    subject: string;
    bodyHtml: string;
    scope: MailTemplateScope;
    createdAt: string;
    updatedAt: string;
}

export interface CreateMailTemplateInput {
    name: string;
    subject: string;
    bodyHtml: string;
    scope?: MailTemplateScope;
}

export interface UpdateMailTemplateInput {
    name?: string;
    subject?: string;
    bodyHtml?: string;
    scope?: MailTemplateScope;
}

const fetchJson = async <T>(input: string, init?: RequestInit): Promise<T> => {
    const res = await fetch(input, init);
    if (!res.ok) {
        const text = await res.text().catch(() => "");
        let message = `${res.status} ${res.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) {
                message = Array.isArray(parsed.message)
                    ? parsed.message.join(", ")
                    : String(parsed.message);
            }
        } catch {
            if (text) message = text;
        }
        throw new Error(message);
    }
    // DELETE liefert { ok: true } oder leeren Body — defensiv parsen.
    const raw = await res.text().catch(() => "");
    return (raw ? JSON.parse(raw) : (undefined as unknown)) as T;
};

export const mailTemplateService = {
    async list(): Promise<MailTemplate[]> {
        return fetchJson<MailTemplate[]>(apiUrl("mail/templates"));
    },

    async create(input: CreateMailTemplateInput): Promise<MailTemplate> {
        return fetchJson<MailTemplate>(apiUrl("mail/templates"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(input),
        });
    },

    async update(id: number, patch: UpdateMailTemplateInput): Promise<MailTemplate> {
        return fetchJson<MailTemplate>(apiUrl(`mail/templates/${id}`), {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(patch),
        });
    },

    async remove(id: number): Promise<void> {
        await fetchJson(apiUrl(`mail/templates/${id}`), { method: "DELETE" });
    },
};
